import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

// A small labelled choice of one: [Line | Bar], [Week | Month | Year].
export const Segmented = ({ label, options, value, onChange }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    color="primary"
    value={value}
    onChange={(_, v) => v != null && onChange(v)}
    aria-label={label}
    sx={{ flexShrink: 0 }}
  >
    {options.map((o) => (
      <ToggleButton key={o.value} value={o.value} sx={{ textTransform: "none", px: 1.5, py: 0.5 }}>
        {o.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
